import { useEffect } from 'react';
import { useFlags as LDUseFlags, useLDClient } from 'launchdarkly-react-client-sdk';

import { useAuth } from '../AuthContext';

export interface Flags {
  alertsEmployeesPerPage: number;
  alertsIdleTimeoutInMinutes: number;
}

export const LaunchDarklyProvider = ({ children }) => {
  const { user } = useAuth();
  const ldClient = useLDClient();

  useEffect(() => {
    if (user && ldClient) {
      ldClient.identify({ key: user.slug });
    }
  }, [user, ldClient]);

  return children;
};

const useFlags = (): Flags => {
  const flags = LDUseFlags();

  return {
    alertsEmployeesPerPage: flags.alertsEmployeesPerPage || 50,
    alertsIdleTimeoutInMinutes: flags.alertsIdleTimeoutInMinutes || 15,
  };
};

export { useFlags };
